const fn = {
  init: () => {
    fn.setupReviews()
    fn.setupForm()
  },

  setupReviews: () => {
    $(document).on('click', '.review-list-item__more', function () {
      const $more = $(this)
      const $reviewContainer = $more.closest('.review-list-item').find('.review-list-item__review')
      const $summary = $reviewContainer.find('.review-list-item__summary')
      const $full = $reviewContainer.find('.review-list-item__full')

      if ($reviewContainer.hasClass('is-expanded')) {
        $reviewContainer.removeClass('is-expanded')
        $reviewContainer.css('min-height', 0)
        $summary.css('position', 'relative').show()
        $full.hide()
        $more.text('+ Read More')
      } else {
        $reviewContainer.addClass('is-expanded')
        $reviewContainer.css('min-height', $full.outerHeight())
        $summary.css('position', 'absolute').fadeOut()
        $full.fadeIn()
        $more.text('- Hide')
      }
    })
  },

  setupForm: () => {
    const $ratingField = $('#ReviewForm_Form_Rating')

    $(document).on('change', '[name=Rating]', function () {
      $ratingField.find('.is-selected').removeClass('is-selected')

      const $holder = $(this).closest('li')

      if ($(this).is(':checked')) {
        $holder.addClass('is-selected')
      }
    })

    $(document).on('mouseover', '#ReviewForm_Form_Rating li', function () {
      $(this).parent().addClass('is-hovering')
    })

    $(document).on('mouseout', '#ReviewForm_Form_Rating li', function () {
      $(this).parent().removeClass('is-hovering')
    })
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-reviewspage'),
  run: fn.init
}
